var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviFitnessDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28h28V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.764 10.589-1.741 1.697a.58.58 0 0 0-.168.513l.412 2.396a.579.579 0 0 1-.84.611l-2.152-1.132a.577.577 0 0 0-.54 0l-2.151 1.132a.58.58 0 0 1-.84-.611l.41-2.396a.579.579 0 0 0-.165-.513l-1.742-1.697a.578.578 0 0 1 .32-.987l2.408-.35a.581.581 0 0 0 .436-.316l1.075-2.181a.579.579 0 0 1 1.038 0l1.077 2.181c.083.17.246.289.435.316l2.406.35a.579.579 0 0 1 .322.987m3.064-5.026C19.89 3.348 16.983 2.018 14.066 2h-.057c-2.925 0-5.834 1.311-7.8 3.517-1.863 2.114-2.703 4.837-2.353 7.689.97 7.745 9.277 12.48 9.628 12.674.148.083.296.12.451.12a.966.966 0 0 0 .454-.111c.35-.203 8.787-4.929 9.765-12.581.36-2.862-.462-5.613-2.326-7.745",
    fill: "#E5E6E8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviFitnessDisabled);
export default __webpack_public_path__ + "static/media/navi-fitness-disabled.f0d1ca663a77318045ab07c3b794a894.svg";
export { ForwardRef as ReactComponent };